// JsFromRoutes CacheKey 55e1e96f39fa056aed0ee9367a95dbfb
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/upgrade'),
}
